import { PrimaryButton, SecondaryButton, Space, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { CreditCardSelect } from '@webapp/modules/accounts-payable/components/CreditCardSelect'
import { type CreditCardAccount } from '@webapp/modules/accounts-payable/entities/CreditCardAccount'
import messages from './messages'
import { StickyBarStyled } from './styles/StickyBarStyled'

export interface IMoveItemsActionBarProps {
  selectedCount: number
  /** Formatted "{amount} {currency}" total of the selected items */
  selectedTotalLabel: string
  /** Excludes the current card from the target picker (BHV-025) */
  sourceAccountId: number
  targetCard: Nullable<CreditCardAccount>
  onTargetCardChange: (account: Nullable<CreditCardAccount>) => void
  onDeselectAll: () => void
  onMove: () => void
  isMoving: boolean
}

// Sticky batch-action bar shown while move mode is on (BHV-021).
export const MoveItemsActionBar = ({
  selectedCount,
  selectedTotalLabel,
  sourceAccountId,
  targetCard,
  onTargetCardChange,
  onDeselectAll,
  onMove,
  isMoving,
}: IMoveItemsActionBarProps) => {
  const intl = useProcurifyIntl()

  return (
    <StickyBarStyled>
      <Space direction='horizontal' justify='space-between' align='center'>
        <Space direction='horizontal' size='large' align='center'>
          <Text autoMargin={false}>
            {intl.formatMessage(messages.selectedSummary, {
              count: selectedCount,
              total: selectedTotalLabel,
            })}
          </Text>
          <SecondaryButton type='button' onClick={onDeselectAll}>
            {intl.formatMessage(messages.deselectAllButton)}
          </SecondaryButton>
        </Space>
        <Space direction='horizontal' align='center'>
          <Space.Item minWidth={280}>
            <CreditCardSelect
              excludeAccountId={sourceAccountId}
              value={targetCard}
              onChange={onTargetCardChange}
            />
          </Space.Item>
          <PrimaryButton type='button' onClick={onMove} isLoading={isMoving}>
            {intl.formatMessage(messages.moveItemsButton)}
          </PrimaryButton>
        </Space>
      </Space>
    </StickyBarStyled>
  )
}

MoveItemsActionBar.displayName = 'MoveItemsActionBar'
